import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { submitKeysOf } from '../components/workflow/useWorkflowPerms';
import WorkflowListShell from '../components/workflow/WorkflowListShell';
import WorkflowStatusBadge from '../components/workflow/WorkflowStatusBadge';
import ReviewerLapsedNote from '../components/workflow/ReviewerLapsedNote';
import { inputCls } from '../components/shared/FormKit';
import { formatDateShort } from '../utils/dateFormat';
import { EngagementName } from '../components/workflow/CoverageDisplay';
import NowName from '../components/shared/NowName';

// Engagement Amendment requests — list page (docs/modules/workflow-amendment.md).
export const EAR_TYPE_LABELS = { update: 'Change Request', access: 'CW / CC Access (Legacy)' };

const WorkflowEar = () => {
  const { hasPermission } = useAuth();
  const [typeFilter, setTypeFilter] = useState('');

  return (
    <WorkflowListShell
      title="Engagement Amendment"
      subtitle="Changes to existing engagements."
      newTo="/workflow/ear/new"
      canCreate={submitKeysOf('ear').some(hasPermission)}
      apiPath="/api/workflow/ear"
      extraParams={{ type: typeFilter }}
      searchPlaceholder="Search request / engagement / requester…"
      rowTo={(r) => `/workflow/ear/${r.id}`}
      filters={(
        <select value={typeFilter} onChange={(e) => setTypeFilter(e.target.value)} className={`${inputCls} sm:w-auto`}>
          <option value="">All types</option>
          <option value="update">Change request</option>
          <option value="access">CW / CC access (legacy)</option>
        </select>
      )}
      columns={[
        {
          key: 'requestNo',
          label: 'Request',
          sortKey: 'requestNo',
          className: 'whitespace-nowrap',
          render: (r) => (
            <Link
              to={`/workflow/ear/${r.id}`}
              onClick={(e) => e.stopPropagation()}
              className="text-blue-600 hover:text-blue-800 font-medium"
            >
              {r.requestNo}
            </Link>
          ),
        },
        { key: 'requestType', label: 'Type', sortKey: 'requestType', className: 'text-slate-700 whitespace-nowrap', render: (r) => EAR_TYPE_LABELS[r.requestType] },
        { key: 'engagement', label: 'Engagement', sortKey: 'engagement', className: 'text-slate-900 max-w-xs', cellTitle: (r) => r.engagementName, render: (r) => <EngagementName name={r.engagementName} now={r.engagementNameNow} serviceDescription={r.serviceDescription} /> },
        { key: 'status', label: 'Status', sortKey: 'status', render: (r) => (<><WorkflowStatusBadge status={r.status} /><ReviewerLapsedNote when={r.reviewerLapsed} /></>) },
        { key: 'reviewer', label: 'Reviewer', sortKey: 'reviewer', className: 'whitespace-nowrap', render: (r) => <NowName value={r.reviewerName} now={r.reviewerNameNow} className="text-slate-600" /> },
        { key: 'requester', label: 'Requester', sortKey: 'requester', className: 'text-slate-600', render: (r) => r.requesterEmail },
        { key: 'createdAt', label: 'Submitted', sortKey: 'createdAt', className: 'text-slate-600 whitespace-nowrap', render: (r) => formatDateShort(r.createdAt) },
      ]}
    />
  );
};

export default WorkflowEar;
